var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoachExpiredStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8159_7138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8159_7138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.4L13.9 13.3C14.0833 13.4833 14.3167 13.575 14.6 13.575C14.8833 13.575 15.1167 13.4833 15.3 13.3C15.4833 13.1167 15.575 12.8833 15.575 12.6C15.575 12.3167 15.4833 12.0833 15.3 11.9L13.4 10L15.3 8.1C15.4833 7.91667 15.575 7.68333 15.575 7.4C15.575 7.11667 15.4833 6.88333 15.3 6.7C15.1167 6.51667 14.8833 6.425 14.6 6.425C14.3167 6.425 14.0833 6.51667 13.9 6.7L12 8.6L10.1 6.7C9.91667 6.51667 9.68333 6.425 9.4 6.425C9.11667 6.425 8.88333 6.51667 8.7 6.7C8.51667 6.88333 8.425 7.11667 8.425 7.4C8.425 7.68333 8.51667 7.91667 8.7 8.1L10.6 10L8.7 11.9C8.51667 12.0833 8.425 12.3167 8.425 12.6C8.425 12.8833 8.51667 13.1167 8.7 13.3C8.88333 13.4833 9.11667 13.575 9.4 13.575C9.68333 13.575 9.91667 13.4833 10.1 13.3L12 11.4ZM6 18L3.7 20.3C3.38333 20.6167 3.02083 20.6875 2.6125 20.5125C2.20417 20.3375 2 20.025 2 19.575V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6ZM5.15 16H20V4H4V17.125L5.15 16Z",
    fill: "#FFC649"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachExpiredStatus);
export default __webpack_public_path__ + "static/media/coachExpiredStatus.9713eaa672f9976f025fa356e687560b.svg";
export { ForwardRef as ReactComponent };